export const USER_ENDPOINTS = {
    UPDATE_PROFILE: `/users/me`,
    DELETE_PROFILE: `/users/me`,
    ADD_MEMBER: `/users/add-member`,
    GET_USERS: `/users`,
    UPDATE_MEMBER: `/users/update-member`,
    REMOVE_MEMBER: `/users/remove-member`,
    GET_ORGANIZATIONS: `/users/organizations`,
    SWITCH_ORGANIZATION: (organizationId: string) => `/users/${organizationId}`,
    RESEND_INVITE: `/users/resend-invitation`,
} as const;

export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    MEMBER: 'member',
} as const;
